/**
 * Copyright IBM Corp. 2022, 2026
 */

import Image from 'next/image'
import classNames from 'classnames'
import { vercelSplit } from '@web/cms'
import { FlightIcon, Text } from '@hashicorp/mds-react/components'
import { getModalType } from 'app/[locale]/abm/_utils/get-modal-type'
import type { ModalType } from 'app/[locale]/abm/_utils/get-modal-type'
import s from './abm-tabs-card.module.css'

interface ABMTabsCardProps {
	isPrimary: boolean
	image: {
		__type?: 'FileField'
		url: string
		width?: number
		height?: number
		alt?: string
	}
	headline: string
	description: string
	href: string
}

const ICON_MAP: Record<ModalType, string> = {
	pdf: 'outline',
	video: 'video',
	externalLink: 'external-link',
}

const ABMTabsCard = ({
	isPrimary,
	image,
	headline,
	description,
	href,
}: ABMTabsCardProps) => {
	return (
		<div
			className={classNames(s.card, {
				[s.isPrimary]: isPrimary,
			})}
		>
			<div className={s.image}>
				<Image
					src={image.url}
					width={image.width}
					height={image.height}
					alt={image.alt || ''}
				/>
			</div>
			<div className={s.content}>
				<Text.DisplayExpressive
					color="strong"
					weight="bold"
					className={s.headline}
				>
					{headline}
				</Text.DisplayExpressive>
				<Text.Body color="faint" size="200" className={s.description}>
					{description}
				</Text.Body>
				<FlightIcon
					name={ICON_MAP[getModalType(vercelSplit(href))]}
					color="var(--mds-color-palette-neutral-500)"
				/>
			</div>
		</div>
	)
}

export { ABMTabsCard }
